/**
 *
 */
export class BoundsType
{
	/**
	 *
	 */
	public static SPHERE:string = "sphere";

	/**
	 *
	 */
	public static AXIS_ALIGNED_BOX:string = "axisAlignedBox";

	/**
	 *
	 */
	public static NULL:string = "null";
}